import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';

type ScenarioOption = {
  user_message: string;
};

type Props = {
  scenario: ScenarioOption;
  scenarioIndex: number;
  total: number;
  response?: string;
  submitting: boolean;
  onChangeResponse: (value: string) => void;
  onNext: () => void;
  onPrev: () => void;
  isLast: boolean;
};

export function ToneBatchWriteStep({
  scenario,
  scenarioIndex,
  total,
  response,
  submitting,
  onChangeResponse,
  onNext,
  onPrev,
  isLast,
}: Props) {
  return (
    <div className="space-y-4">
      <Card className="p-5 space-y-3 shadow-sm">
        <div className="text-xs font-semibold tracking-wide text-muted-foreground">
          Scenario {scenarioIndex + 1} di {total}
        </div>
        <p className="text-base font-medium leading-6">{scenario.user_message}</p>
        <Textarea
          value={response ?? ''}
          onChange={(e) => onChangeResponse(e.target.value)}
          placeholder="Scrivi la tua risposta (consiglio: ~240 caratteri)"
          className="min-h-[120px]"
        />
        <div className="text-xs text-muted-foreground text-right">{response?.length || 0} caratteri</div>
      </Card>
      <div className="flex gap-3 justify-end">
        <Button variant="outline" disabled={submitting || scenarioIndex === 0} onClick={onPrev}>
          Indietro
        </Button>
        <Button disabled={submitting || !response?.trim()} onClick={onNext} isLoading={submitting}>
          {isLast ? 'Conferma' : 'Avanti'}
        </Button>
      </div>
    </div>
  );
}
